var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "boton",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#382900",
    floodOpacity: 0.365
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(-1591.5 -729.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1591.5, 729.5)",
    filter: "url(#boton)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "boton-2",
    "data-name": "boton",
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    transform: "translate(7.5 5.5)",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62",
    "data-name": "Trazado 62",
    d: "M524.68,422.352a20.469,20.469,0,1,0,20.468,20.469A20.492,20.492,0,0,0,524.68,422.352Zm17.581,19.056h-7.7c-.192-6.384-1.675-11.8-3.953-15.2A17.68,17.68,0,0,1,542.262,441.408ZM524.68,460.464c-3.195,0-6.735-6.6-7.055-16.231h14.11C531.416,453.868,527.875,460.464,524.68,460.464Zm-7.055-19.056c.32-9.634,3.861-16.231,7.055-16.231s6.735,6.6,7.054,16.231Zm1.126-15.2c-2.277,3.407-3.76,8.819-3.952,15.2h-7.7A17.681,17.681,0,0,1,518.75,426.2ZM507.1,444.233h7.7c.192,6.384,1.675,11.8,3.952,15.2A17.679,17.679,0,0,1,507.1,444.233Zm23.51,15.2c2.278-3.406,3.761-8.819,3.953-15.2h7.7A17.679,17.679,0,0,1,530.609,459.436Z",
    transform: "translate(1112.788 330.648)",
    fill: "#906B33"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWeb);
export default __webpack_public_path__ + "static/media/logoWeb.18f400b649e16a53ab44f20f3560fa19.svg";
export { ForwardRef as ReactComponent };